import { FC } from 'react';

import classNames from 'classnames';

import { Hint, HintProps } from '../../Hint';

import styles from '../FormControl/FormControl.module.scss';

export const FormHint: FC<HintProps> = ({ children, ...props }) => {
  return (
    <div className={classNames(styles.inline)}>
      <Hint {...props}>{children}</Hint>
    </div>
  );
};
